/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { showModal, getEvolutionPlanTrainingPreRequisites } from "actions";
import EvolutionPlanPreRequisiteBody, {
  EvolutionPlanPreRequisiteTitle,
} from "components/evolutionPlan/EvolutionPlanPreRequisite";
import { Trans } from "react-i18next";

class EvolutionPlanPlans extends Component {
  embedClassName = (evolutionPlanStatus) => {
    if (evolutionPlanStatus === "Success") return "tamamlanmisEgitim";
    if (evolutionPlanStatus === "Fail") return "tekrarlanmasiGerekenEgitim";
    if (evolutionPlanStatus === "Registered") return "kayitliEgitim";
  };

  renderPrerequisiteModal = (trainingId, trainingName) => {
    this.props.showModal({
      modalType: "epPreReq",
      modalTitle: <EvolutionPlanPreRequisiteTitle />,
      modalContent: (
        <EvolutionPlanPreRequisiteBody
          employeeId={this.props.employeeId}
          trainingId={trainingId}
          trainingName={trainingName}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderIcon = (plan) => {
    if (plan.fordRole === true)
      return <span className="icon-icon-fordrol mr-1"></span>;
    else if (plan.targetedPosition === true)
      return <span className="icon-icon-menu-vision1 mr-1"></span>
    else return null;
  };

  renderDetail = () => {
    let arr = this.props.plans;
    if (!this.props.showCompleted) {
      arr = arr.filter((p) => p.success === false);
    }
    return arr.map((plan) => {
      return (
        <tr
          key={plan.training.id}
          className={this.embedClassName(plan.evolutionPlanStatus)}
        >
          <td className="showGrup">{plan.method?.label}</td>
          <td className="showGrup">
            {this.renderIcon(plan)}
            {plan.training?.name}
          </td>
          <td className="showGrup">{plan.location}</td>
          <td className="showGrup">
            {plan.duration}
            <sup>
              <Trans desc="GÜN">10388</Trans>
            </sup>
          </td>
          <td className="showGrup">{plan.weight.toFixed(2)}</td>
          <td className="showGrup">{plan.futureWeight.toFixed(2)}</td>
          <td>
            {plan.havePreRequisite ? (
              <a
                onClick={() =>
                  this.renderPrerequisiteModal(
                    plan.training.id,
                    plan.training.name
                  )
                }
                className="btn btn-fga-view"
              >
                <Trans desc="Göster">10143</Trans>{" "}
                <span className="iconmford fo-icon-search" style={{ fontSize: 0 }}></span>
              </a>
            ) : null}
          </td>
          <td></td>
        </tr>
      );
    });
  };

  render() {
    return (
      <tr>
        <td>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="row pb-3">
                {/* <div className="col-xs-12 col-sm-12 offset-md-10 col-md-2 offset-lg-10 col-lg-2 tableSearchArea">
                  <div className="inner-addon right-addon">
                    <span className="iconmford fo-icon-search"></span>
                    <input
                      type="text"
                      name="tableSearch"
                      id="tableSearch"
                      className="form-control"
                      placeholder="Bul"
                    />
                  </div>
                </div> */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
                  <table className="table display responsive kE">
                    <thead>
                      <tr>
                        <th className="all">
                          <div className="tableTitle">
                            <Trans desc="Tür">10014</Trans>
                          </div>
                        </th>
                        <th className="all">
                          <div className="tableTitle">
                            <Trans desc="Eğitim Adı">10015</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Yer">10016</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Süre">10017</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Mevcut Dönem Eğitim Ağırlığı">
                              10513
                            </Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Gelecek Dönem Eğitim Ağırlığı">
                              10514
                            </Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Ön Şart">10159</Trans>
                          </div>
                        </th>
                        <th className="none"></th>
                      </tr>
                    </thead>
                    <tbody>{this.renderDetail()}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modal: state.modal,
    application: state.application,
    plans: state.evolutionPlan.data.evolutionPlans.find(
      (p) => p.level.id === ownProps.id
    )?.plans,
  };
};

export default connect(mapStateToProps, {
  showModal,
  getEvolutionPlanTrainingPreRequisites,
})(EvolutionPlanPlans);
